import styled from 'styled-components';

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 0.7rem;
`;

export const FieldGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 31px;
  margin-right: auto;
  margin-left: auto;
  margin: 0.2rem auto;
  width: 100%;
`;

export const FieldTitle = styled.div`
  font-weight: 600;
  width: 25%;
  text-align: right;
  margin-right: 1.5rem;
`;

export const FieldData = styled.div`
  width: 40%;
  text-align: left;
  display: flex;
  flex-direction: column;
`;
